/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const instanceTypeMappingCreateRequestSchema = z.object({
  defaultSourceState: z.string().nullish(),
  itemTypeId: z.int(),
  sourceTypeId: z.string(),
});
